export type TrackingProps = {
  utmCampaign?: string;
  utmContent?: string;
  utmMedium?: string;
  utmSource?: string;
  utmTerm?: string;
  hsaAcc?: string;
  hsaCam?: string;
  hsaGrp?: string;
  hsaAd?: string;
  hsaNet?: string;
  hsaSrc?: string;
  hsaMt?: string;
  hsaKw?: string;
  hsaTgt?: string;
};

/* HubSpot's field names are the query-string names, so one map serves capture and submission. */
export const TRACKING_PARAMS: Record<string, keyof TrackingProps> = {
  utm_campaign: 'utmCampaign',
  utm_content: 'utmContent',
  utm_medium: 'utmMedium',
  utm_source: 'utmSource',
  utm_term: 'utmTerm',
  hsa_acc: 'hsaAcc',
  hsa_ad: 'hsaAd',
  hsa_cam: 'hsaCam',
  hsa_grp: 'hsaGrp',
  hsa_kw: 'hsaKw',
  hsa_mt: 'hsaMt',
  hsa_net: 'hsaNet',
  hsa_src: 'hsaSrc',
  hsa_tgt: 'hsaTgt',
};

export const defaultTracking = {
  utmCampaign: undefined,
  utmContent: undefined,
  utmMedium: undefined,
  utmSource: undefined,
  utmTerm: undefined,
  hsaAcc: undefined,
  hsaCam: undefined,
  hsaGrp: undefined,
  hsaAd: undefined,
  hsaSrc: undefined,
  hsaMt: undefined,
  hsaNet: undefined,
  hsaKw: undefined,
  hsaTgt: undefined,
};

export type TrackingStorageState = {
  data: TrackingProps;
  update: (data: Partial<TrackingProps>) => void;
  reset: () => void;
};
